var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25067 0.696699C5.11333 0.769366 4.93067 0.955366 4.85867 1.09603C4.78267 1.2447 4.78267 1.42137 4.85933 1.57537C4.90133 1.65803 5.46133 2.23737 6.73533 3.51337L8.55267 5.33337H4.63067C0.422667 5.33337 0.574 5.3287 0.381334 5.46603C0.233334 5.57137 0.18 5.71203 0.18 6.00003C0.18 6.2207 0.188667 6.2687 0.246667 6.37203C0.32 6.50337 0.442667 6.5987 0.59 6.63937C0.652667 6.6567 2.06733 6.6667 4.61933 6.6667H8.55267L6.73533 8.4867C5.46133 9.7627 4.90133 10.342 4.85933 10.4247C4.742 10.66 4.80133 10.9027 5.03267 11.134C5.264 11.3654 5.50667 11.4247 5.742 11.3074C5.82533 11.2654 6.55133 10.56 8.20733 8.9107C9.498 7.62537 10.5887 6.5507 10.6307 6.5227C10.7333 6.4547 10.866 6.15937 10.866 6.00003C10.866 5.82937 10.734 5.54737 10.6173 5.46737C10.5673 5.43337 9.47667 4.3587 8.19333 3.0787C6.61667 1.50603 5.82333 0.734033 5.748 0.696033C5.60133 0.6227 5.39 0.623366 5.25067 0.696699Z",
    fill: "#1E1E1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowV2);
export default __webpack_public_path__ + "static/media/right_arrow_v2.svg";
export { ForwardRef as ReactComponent };